/**
 * API Đơn (Filing) – POC dùng mock; triển khai thật dùng cùng endpoint với backend.
 */
import { apiSlice } from './apiSlice'
import type { Filing, FilingCreate } from '../../types/filing'

export const filingsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getFilingsByCase: builder.query<Filing[], string>({
      query: (caseId) => ({ url: `filings?case_id=${encodeURIComponent(caseId)}`, method: 'GET' }),
      providesTags: (_result, _err, caseId) => ['Filings', { type: 'Case', id: caseId }],
    }),
    getFilingById: builder.query<Filing, string>({
      query: (id) => ({ url: `filings/${id}`, method: 'GET' }),
      providesTags: (_result, _err, id) => [{ type: 'Filings', id }],
    }),
    createFiling: builder.mutation<Filing, FilingCreate>({
      query: (body) => ({ url: 'filings', method: 'POST', body }),
      invalidatesTags: ['Filings'],
    }),
  }),
})

export const { useGetFilingsByCaseQuery, useGetFilingByIdQuery, useCreateFilingMutation } = filingsApi
